/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Filters, IndexTable, Modal, Stack, useIndexResourceState } from '@shopify/polaris';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { stateConverter } from '../FilterEngine/filterParams';
import useDebounce from '../../hooks/useDebounce';
import { handleFilterChange } from '../FilterEngine/FilterEngine';
import TablePagination from '../FilterEngine/TablePagination/TablePagination';
import StatusBadge from '../Shared/StatusBadge';

const AddClientModal = (props) => {
  const [showProducts, setShowProducts] = useState(true);
  const [lastPage, setLastPage] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingLength] = useState(20);

  const { t } = useTranslation();
  const location = useLocation();
  const history = useNavigate();

  const [tableFilters, setTableFilters] = useState(stateConverter(location));
  const debouncedSearch = useDebounce(tableFilters, 400);

  const closeModal = () => {
    setShowProducts(false);
    props.close();
  };

  const handleSubmit = () => {
    const params = {
      instructor_tokens: selectedResources
    };

    setLoading(true);

    axios.post(`/v1/public_profiles/${props.publicProfile.url_name}/assign_clients`, params)
      .then(() => {
        props.handleSubmit();
        props.close();
      })
      .catch(() => {
      })
      .then(() => {
        setLoading(false);
      });
  };

  const fetchProducts = useCallback(() => {
    const params = {
      per_page: loadingLength,
      page: tableFilters.page,
      search: tableFilters.queryValue,
      q: { aasm_state_eq: 'validated' },
      s: { sorts: tableFilters.sorts }
    };

    axios.post('/v1/clients/search', params)
      .then((response) => {
        const temp = [...response.data.clients];
        props.selectedProducts.forEach((token) => {
          const index = temp.findIndex((product) => product.user_token === token);
          if (index >= 0) temp[index].assigned = true;
        });

        setProducts(temp);
        setLastPage(response.data.lastPage);
      })
      .catch(() => {});
    // eslint-disable-next-line
  }, [debouncedSearch]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const appliedFilters = useCallback(() => {
    const af = [];

    return af;
  }, []);

  const resourceName = {
    singular: t('client.client'),
    plural: t('client.clients')
  };

  const filters = [];

  const placeHolderText = t('user.search');

  const filterControl = (
    <Filters
      queryValue={tableFilters.queryValue}
      filters={filters}
      onQueryChange={handleFilterChange({ history, location }, setTableFilters, 'queryValue')}
      onQueryClear={handleFilterChange({ history, location }, setTableFilters, 'queryValue', 'reset', '')}
      appliedFilters={appliedFilters()}
      queryPlaceholder={placeHolderText}
    />
  );

  const headings = [
    { title: t('user.name') },
    { title: t('shared.email') },
    { title: t('staff.assigned') }
  ];

  const {
    selectedResources,
    allResourcesSelected,
    handleSelectionChange
  } = useIndexResourceState(products);

  const rowMarkup = products.map(({ id, user_token, token, name, email, assigned }, index) => (
    <IndexTable.Row
      id={user_token}
      key={user_token}
      selected={selectedResources?.includes(user_token)}
      position={index}
    >
      <IndexTable.Cell>
        <Button plain url={`/clients/${token}`}>{name}</Button>
      </IndexTable.Cell>
      <IndexTable.Cell>
        {email}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <StatusBadge active={assigned} />
      </IndexTable.Cell>
    </IndexTable.Row>
  ));

  const promotedBulkActions = [
    {
      content: t('product.toggle_access'),
      onAction: () => handleSubmit()
    }
  ];

  return (
    <Modal
      open={showProducts}
      onClose={closeModal}
      title={props.title}
    >
      <Modal.Section>
        <Stack>
          <Stack.Item fill>
            {filterControl}
          </Stack.Item>
        </Stack>
        <IndexTable
          resourceName={resourceName}
          headings={headings}
          rows={products}
          itemCount={products.length}
          loading={loading}
          selectedItemsCount={
            allResourcesSelected ? 'All' : selectedResources.length
          }
          onSelectionChange={handleSelectionChange}
          promotedBulkActions={promotedBulkActions}
        >
          {rowMarkup}
        </IndexTable>
        <TablePagination
          resetOnRefresh
          pageFilter={tableFilters.page}
          setTableFilters={setTableFilters}
          records={products}
          lastPage={lastPage}
          length={loadingLength}
        />
      </Modal.Section>
    </Modal>
  );
};

export default AddClientModal;
